<template>
    <div
        v-if="
            state.currentView == 'APPLEPAY_INIT_VIEW' && state.processing != true
        "
    >
        <h5
            class="container__col-md-12 container__col-sm-12 payment__instruction"
        >
            {{ $t("applepay.init.description") }}
        </h5>
        <PrimaryButton
            :content="$t('applepay.pay.btn')"
            :current-method="'applepay'"
            @click="Next" 
        />
    </div>
    <div
        v-else-if="
            state.currentView == 'REDIRECT_VIEW' && state.processing != true
        "
    >
        <div class="redirect-wrapper">
            <svg width="77" height="37" viewBox="0 0 77 37" fill="none" xmlns="http://www.w3.org/2000/svg" class="redirect-icon--applepay">
                <path d="M15.5186 20.2951C15.4899 17.4049 17.8755 16.0187 17.9822 15.9486C16.6414 13.9883 14.5526 13.7193 13.8092 13.6887C12.0329 13.5083 10.3415 14.7349 9.44042 14.7349C8.54117 14.7349 7.14892 13.7151 5.67598 13.7411C3.73834 13.7698 1.95235 14.8681 0.955236 16.6026C-1.05707 20.0934 0.440448 25.2668 2.40128 28.1C3.3599 29.4848 4.5031 31.0431 6.00294 30.986C7.44852 30.929 7.99392 30.051 9.74141 30.051C11.4889 30.051 11.9796 30.986 13.5086 30.9568C15.0632 30.9285 16.0487 29.5455 16.9995 28.1551C18.1 26.5463 18.5531 24.9885 18.58 24.9097C18.5461 24.8939 15.5497 23.7461 15.5186 20.2951Z" fill="#2A3362"/>
                <path d="M12.6454 11.8137C13.4407 10.8481 13.9797 9.50641 13.8331 8.17075C12.6853 8.21712 11.2958 8.93365 10.4717 9.8983C9.73335 10.7544 9.08778 12.1175 9.26076 13.429C10.5412 13.5282 11.8472 12.7774 12.6454 11.8137Z" fill="#2A3362"/>
                <path d="M34.9316 9.6244C37.0751 9.6244 38.7779 10.2454 40.0399 11.4874C41.322 12.7094 41.963 14.312 41.963 16.2952C41.963 18.3385 41.312 19.9712 40.0099 21.1932C38.7278 22.3951 36.995 22.9961 34.8114 22.9961H30.3342V30.6585H26.4879V9.6244H34.9316ZM34.4208 19.5405C35.5426 19.5405 36.404 19.25 37.005 18.6691C37.606 18.0881 37.9064 17.2969 37.9064 16.2952C37.9064 15.3136 37.606 14.5324 37.005 13.9514C36.404 13.3705 35.5727 13.08 34.5109 13.08H30.3342V19.5405H34.4208ZM58.3201 27.7739H58.6807V30.6585H57.0581C55.4755 30.6585 54.4639 30.0576 54.0232 28.8556C52.9214 30.2579 51.2687 30.959 49.0651 30.959C47.4625 30.959 46.1704 30.5884 45.1888 29.8472C44.2273 29.086 43.7465 27.9842 43.7465 26.5419C43.7465 25.1796 44.1972 24.1179 45.0987 23.3567C46.0202 22.5754 47.2221 22.1147 48.7045 21.9744L53.3921 21.4937V20.8626C53.3921 20.0613 53.1618 19.4503 52.701 19.0297C52.2403 18.609 51.6293 18.3986 50.868 18.3986C49.3255 18.3986 48.4241 19.1499 48.1636 20.6523H44.3174C44.4777 19.0497 45.1387 17.7676 46.3006 16.8061C47.4625 15.8245 48.985 15.3337 50.868 15.3337C52.7511 15.3337 54.2836 15.8245 55.4655 16.8061C56.6474 17.7676 57.2384 19.21 57.2384 21.1331V26.632C57.2384 27.3932 57.599 27.7739 58.3201 27.7739ZM53.3921 24.8591V24.138L50.0267 24.4985C48.404 24.6788 47.5927 25.3099 47.5927 26.3916C47.5927 27.4734 48.3039 28.0142 49.7262 28.0142C50.6877 28.0142 51.5391 27.7638 52.2803 27.263C53.0215 26.7422 53.3921 25.9409 53.3921 24.8591ZM62.7854 36.9688C62.0042 36.9688 61.1928 36.8586 60.3515 36.6382V33.7836C60.9324 33.9038 61.4533 33.9639 61.914 33.9639C63.5767 33.9639 64.6785 33.2928 65.2194 31.9506L65.7302 30.6585H64.5283L58.7889 15.6342H62.7554L66.842 26.7221H67.0824L70.8986 15.6342H74.865L68.7952 32.5216C67.7936 35.4864 65.7903 36.9688 62.7854 36.9688Z" fill="#2A3362"/>
            </svg>
        </div>
        <p class="container__col-md-12 container__col-sm-12 payment__instruction--applepay">
            {{ $t("applepay.redirect.description") }}
        </p>
        <PrimaryButton
            :content="$t('applepay.pay.btn')"
            :current-method="'applepay'"
            @click="Next" 
        />
    </div>
</template>

<script>
import { 
    ref, 
    onBeforeUnmount, 
} from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, autoInitialize } from "@/support/helpers";
import { onUpdated } from "@vue/runtime-core";

import PrimaryButton from "@/components/form/base-button";
export default {
    name: "ApplePay",
    components: {
        PrimaryButton,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const autoInitializePayment = autoInitialize("APPLEPAY_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        onBeforeUnmount(() => {
            subscription();
        });


        return  {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            Next,
        };
    },
};
</script>